import { render, staticRenderFns } from "./TreatmentCompletedMicroneedlingEmailTemplate.vue?vue&type=template&id=ced27332&scoped=true"
import script from "./TreatmentCompletedMicroneedlingEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentCompletedMicroneedlingEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCompletedMicroneedlingEmailTemplate.vue?vue&type=style&index=0&id=ced27332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced27332",
  null
  
)

export default component.exports